import React from 'react';
import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import * as S from './Colour.style';
import { COLOUR_FRAME } from '@modules/paint-picker/config';
import type { RGB } from '@modules/paint-picker/type';

interface ColourProps {
    rgb: RGB;
    show: boolean;
}

export const Colour = ({ rgb, show }: ColourProps) => {
    const { desktop } = useAppDisplayModeContext();
    const { css } = useStyles({ rgb, show, frame: COLOUR_FRAME, desktop });
    return (
        <div className={css(S.Container)}>
            <div className={css(S.Colour)} />
        </div>
    );
};
